"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "val-di-nizza": {
    "4e639dc4": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "bozzola": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea88eeb4": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "ca-d-agosto": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6cd8bfab": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "ca-zanellino": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e374d332": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "calghera": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "68bceb8c": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "casa-andrini": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a820d44": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "casa-balestrieri": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f7ee44a8": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "casa-leone": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18b20345": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "casa-porri": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "91e278ff": [{
      "hkey": "7b4baa02",
      "slug": "casa-ponte",
      "name": "Casa Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "casa-schiavo": [{
      "hkey": "7b4baa02",
      "slug": "casa-ponte",
      "name": "Casa Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "val-di-nizza"
    }],
    "1fe14798": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "casa-superiore": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "352e7541": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "costa-croce": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "efacae60": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "mandasco": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e8acbaa9": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "mombelli": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0302676b": [{
      "hkey": "d4838265",
      "slug": "montacuto",
      "name": "Montacuto",
      "primary": true,
      "skipSearch": false
    }],
    "monteacuto": [{
      "hkey": "d4838265",
      "slug": "montacuto",
      "name": "Montacuto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ef8fc16b": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "skipSearch": false
    }],
    "oramala": [{
      "hkey": "54e6df0d",
      "slug": "val-di-nizza",
      "name": "Val di Nizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;